import { React,StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import JoinUs from "./pages/JoinUs";
import LeadUs from "./pages/LeadUs";
import InMemorium from "./pages/InMemorium";
import CurrentPlans from "./pages/CurrentPlans";
import Instructions from "./pages/Instructions";
import Application from "./pages/Application";
import PastEvents from "./pages/PastEvents";
import Payments from "./pages/Payments";
import Navbar from './Common/Navbar';


// import reportWebVitals from './reportWebVitals';

export default function App() {
  return (
    <BrowserRouter>
    <div className='App'>
      <Navbar />
      <Routes>
          <Route path="/" index element={<Home />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/ContactUs" element={<ContactUs/>} />
          <Route path="/JoinUs" element={<JoinUs />} />
          <Route path="/LeadUs" element={<LeadUs />} />
          <Route path="/InMemorium" element={<InMemorium />} />
          <Route path="/CurrentPlans" element={<CurrentPlans />} />
          <Route path="/Instructions" element={<Instructions />} />
          <Route path="/Application" element={<Application />} />
          <Route path="/PastEvents" element={<PastEvents />} />
          <Route path="/Payments" element={<Payments />} />
          <Route path="*" element={<NoPage />} />
      </Routes>
      </div>
    </BrowserRouter>
  );
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <App/>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
